module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Label":"Save"},"fr":{"Label":"Sauvegarder"}}')
  delete Component.options._Ctor
}
